exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dmb-web__Modal__regionReportModal__2h7dP {\n  padding: 0;\n  border-radius: 5px;\n}\n\n.dmb-web__Modal__enhancedScoutingModal__2yuPi, .dmb-web__Modal__scoutingModal__3IwwE {\n  padding: 0;\n}\n\n.dmb-web__Modal__enhancedScoutingModal__2yuPi {\n  margin-top: 2dvh;\n}\n", ""]);

// exports
exports.locals = {
	"regionReportModal": "dmb-web__Modal__regionReportModal__2h7dP",
	"enhancedScoutingModal": "dmb-web__Modal__enhancedScoutingModal__2yuPi",
	"scoutingModal": "dmb-web__Modal__scoutingModal__3IwwE"
};